import { equipmentsListName, linesListName } from "src/api/config";
import { KeysList } from "../type";

export const keyMap: Record<KeysList, string> = {
  collections: "Collection",
  departments: "Department",
  sectors: "Sector",
  processes: "Process",
  types: "DocType",
  lines: linesListName,
  critical: "Critical",
  model: equipmentsListName,
  sap: equipmentsListName,
  manufacturer: equipmentsListName,
  titleEquipment: equipmentsListName,
  typeEquipment: equipmentsListName,
  created: "AuthorEmail",
  responsibleForRevision: "ResponsibleForRevisionEmail",
  dateForRevision: "DateForRevision",
  workstations: "WorkPlaces",
  notificationStatus: "notificationStatus",
  notificationType: "notificationType",
  templateOWD: "templateOWD",
};
